import { render, staticRenderFns } from "./InitiateActionTableCell.vue?vue&type=template&id=90f97b24&scoped=true"
import script from "./InitiateActionTableCell.vue?vue&type=script&lang=js"
export * from "./InitiateActionTableCell.vue?vue&type=script&lang=js"
import style0 from "./InitiateActionTableCell.vue?vue&type=style&index=0&id=90f97b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f97b24",
  null
  
)

export default component.exports